var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { buildDemoSummaryTeamAverageDiff } from '@web/lib/demo/utils';
import { getPercentageDiff, randomInt } from '@workalizer/shared/utils';
var buildCountMetric = function (count, previousCount, includeTeamAverage) {
    if (includeTeamAverage === void 0) { includeTeamAverage = false; }
    return (__assign({ count: count, previous: getPercentageDiff(previousCount, count) }, (includeTeamAverage
        ? { teamAverage: buildDemoSummaryTeamAverageDiff(count) }
        : {})));
};
export var driveSummary = function (input) {
    var includeTeamAverage = input.userId != null;
    var created = randomInt(25, 45);
    var previousCreated = randomInt(30, 55);
    var edited = randomInt(180, 280);
    var previousEdited = randomInt(200, 320);
    var viewed = randomInt(650, 900);
    var previousViewed = randomInt(600, 850);
    var commentsAdded = randomInt(40, 70);
    var previousCommentsAdded = randomInt(45, 80);
    var commentsResolved = randomInt(25, 50);
    var previousCommentsResolved = randomInt(30, 55);
    var suggestionsAdded = randomInt(20, 40);
    var previousSuggestionsAdded = randomInt(22, 45);
    var suggestionsResolved = randomInt(12, 28);
    var previousSuggestionsResolved = randomInt(14, 32);
    var shared = randomInt(55, 95);
    var previousShared = randomInt(45, 80);
    var sharedExternally = randomInt(12, 30);
    var previousSharedExternally = randomInt(10, 25);
    return {
        created: buildCountMetric(created, previousCreated, includeTeamAverage),
        edited: buildCountMetric(edited, previousEdited, includeTeamAverage),
        viewed: buildCountMetric(viewed, previousViewed, includeTeamAverage),
        commentsAdded: buildCountMetric(commentsAdded, previousCommentsAdded, includeTeamAverage),
        commentsResolved: buildCountMetric(commentsResolved, previousCommentsResolved, includeTeamAverage),
        suggestionsAdded: buildCountMetric(suggestionsAdded, previousSuggestionsAdded, includeTeamAverage),
        suggestionsResolved: buildCountMetric(suggestionsResolved, previousSuggestionsResolved, includeTeamAverage),
        shared: buildCountMetric(shared, previousShared, includeTeamAverage),
        sharedExternally: buildCountMetric(sharedExternally, previousSharedExternally, includeTeamAverage)
    };
};
